import moment from "moment";
import { cloneElement, memo, useMemo } from "react";
import { BinIcon } from "../../../components/icon/Icon.jsx";
import { BonusTitleTimerStyled } from "../styled/BonusTitleStyled.js";

export const BonusTime = memo(({seconds, children}) => {
    const time = useMemo(() => {
        const duration = moment.duration(seconds, 'seconds');
        const format = duration.asHours() < 1 ? "mm:ss" : "HH:mm:ss";
        return moment.utc(duration.asMilliseconds()).format(format);
    }, [seconds]);
    return (
        children
            ? cloneElement(children, {time})
            : (
                <BonusTitleTimerStyled>
                    <BinIcon name="IcStopwatch" style={{ fontSize: '16px' }}/>
                    <div>
                        {time}
                    </div>
                </BonusTitleTimerStyled>
            )
    );
});
